module.exports = __webpack_public_path__ + "3b6d74d196190cb30453a9409045898e.png";